<template>
  <div class="row">
    <div class="col-12 col-lg-8">
      <div class="card">
        <div class="card-header">
          <h4>الإعدادات</h4>
        </div>
        <div class="card-body">
          <div class="alert alert-info" dir="rtl">
            تحديد طريقة الإرسال المستخدمة في الرابط:
            <code>/send/mOvbUHu0u</code>
          </div>

          <div v-if="loading" class="col-12 text-center">
            <img
              :src="require('@/assets/images/loading.svg')"
              style="width: 100px; height: 100px"
              alt=""
            />
          </div>

          <div v-else>
            <div class="form-group" dir="rtl">
              <label class="font-weight-bold">طريقة الإرسال</label>

              <div class="form-check mt-2">
                <input
                  class="form-check-input"
                  type="radio"
                  id="method-sms"
                  value="sms"
                  v-model="method"
                />
                <label class="form-check-label" for="method-sms">
                  <strong>SMS</strong>
                  - الإرسال عبر بوابة الرسائل النصية
                </label>
              </div>

              <div class="form-check mt-2">
                <input
                  class="form-check-input"
                  type="radio"
                  id="method-oldWhats"
                  value="oldWhats"
                  v-model="method"
                />
                <label class="form-check-label" for="method-oldWhats">
                  <strong>واتساب القديم</strong>
                  - عبر الجهاز 966580200670
                </label>
              </div>

              <div class="form-check mt-2">
                <input
                  class="form-check-input"
                  type="radio"
                  id="method-newWhats"
                  value="newWhats"
                  v-model="method"
                />
                <label class="form-check-label" for="method-newWhats">
                  <strong>واتساب الجديد</strong>
                  - عبر new.smart-whats.com API
                </label>
              </div>
            </div>

            <div class="text-left mt-3">
              <button
                class="btn btn-primary"
                :disabled="saving"
                @click="save()"
              >
                <i class="fa fa-save"></i>
                {{ saving ? "جاري الحفظ..." : "حفظ الإعدادات" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: JSON.parse(localStorage.getItem("user")),
      method: "oldWhats",
      loading: true,
      saving: false,
    };
  },
  created() {
    this.load();
  },
  methods: {
    load() {
      var g = this;
      $.post(api + "/admin/general/get-send-method", {
        jwt: this.user.jwt,
      })
        .then(function (r) {
          if (r.status == 100 && r.response && r.response.method) {
            g.method = r.response.method;
          }
          g.loading = false;
        })
        .catch(function () {
          g.loading = false;
          alert("حدث خطأ في الاتصال بالسيرفر.");
        });
    },
    save() {
      var g = this;
      g.saving = true;
      $.post(api + "/admin/general/set-send-method", {
        jwt: this.user.jwt,
        method: this.method,
      })
        .then(function (r) {
          g.saving = false;
          if (r.status == 100) {
            alert("تم حفظ الإعدادات بنجاح.");
          } else {
            alert(r.response || "تعذر الحفظ.");
          }
        })
        .catch(function () {
          g.saving = false;
          alert("حدث خطأ في الاتصال بالسيرفر.");
        });
    },
  },
};
</script>

<style></style>
